// @ts-check
import React from "react"
import { isTaskReportItem } from "../../../utils/report.utils"

/**
 * @param {import("./CategoryCell.molecule").CategoryCellProps<import("../../../services/reports.service.types").AnyTaskReportItem>} props
 * @returns {JSX.Element | null}
 */
export function CategoryCell(props) {
  const { ctx, isHoldingModifierDown, onLeftClickCategoryName } = props
  const { row, table, getValue } = ctx
  const category = getValue()
  const rowData = row.original
  const isTask = isTaskReportItem(rowData)

  if (row.getIsGrouped() || !isTask) {
    return null
  }

  return (
    <div
      className={`overflow-hidden white-space-nowrap text-overflow-ellipsis ${
        isHoldingModifierDown ? "ctrl-selectable" : ""
      }`}
      onClick={() => {
        if (isHoldingModifierDown) {
          const categoryValue =
            rowData.specialCategoryId ?
              `special:${rowData.specialCategoryId}`
            : `normal:${rowData.categoryId}`

          onLeftClickCategoryName?.(table, categoryValue)
        }
      }}
      title={rowData.specialCategoryTitle || category || ""}
    >
      {rowData.specialCategoryTitle || category}
    </div>
  )
}
